var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealmeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1919 7.15408C15.5628 7.07349 13.7169 7.05274 12.7327 7.91597C12.2382 8.35064 11.9971 8.97944 11.9971 9.83902V15.6497H9.76437V9.83902C9.76437 8.33843 10.2846 7.09303 11.2675 6.23468C13.1917 4.55705 16.1552 4.90136 16.4882 4.94654L16.1919 7.15408ZM7.57941 9.91228C7.3297 10.4495 6.84008 10.7169 6.13991 10.7169C5.42873 10.7169 4.9391 10.4495 4.69919 9.91228C4.59269 9.6925 4.55475 9.44342 4.55475 9.12718C4.55475 8.8024 4.59269 8.56187 4.69919 8.33232C4.9391 7.79631 5.42873 7.53747 6.13991 7.53747C6.84008 7.53747 7.3297 7.79631 7.57941 8.33232C7.68468 8.56187 7.72385 8.8024 7.72385 9.12718C7.72385 9.44342 7.68468 9.6925 7.57941 9.91228ZM9.99939 0.00156323C9.99939 0.00156323 0 -0.302461 0 7.56921C0 15.4397 4.75304 22 9.99939 22C15.247 22 20 15.4397 20 7.56921C20 -0.302461 9.99939 0.00156323 9.99939 0.00156323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealmeIcon);
export default __webpack_public_path__ + "static/media/realme-icon.17da748ee3162318d11268eb15f05a3d.svg";
export { ForwardRef as ReactComponent };